import { Flex, Image, Text } from "@chakra-ui/react";
import { Button } from "@kiddocare-platform/portal-common/ui";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage: FC = () => {

	const navigate = useNavigate();

	// const users: CarouselUser[] = [
	// 	{ id: 1, name: "Mario Rossi", avatar: "https://i.pravatar.cc/300?img=1" },
	// 	{ id: 2, name: "Giulia Bianchi", avatar: "https://i.pravatar.cc/300?img=2" },
	// 	{ id: 3, name: "Luca Verdi", avatar: "https://i.pravatar.cc/300?img=3" },
	// 	{ id: 4, name: "Sara Neri", avatar: "https://i.pravatar.cc/300?img=4" },
	// 	{ id: 5, name: "Andrea Gallo", avatar: "https://i.pravatar.cc/300?img=5" },
	// ]


	return (
		<>
			<Flex direction="column" justifyContent="center" alignItems="center" minH="100vh" w="100%" bgColor="primaryParent.200" px={6}>
				<Flex direction="column" justifyContent="center" alignItems="center" gap={8}>
					<Image alt="Welcome" src="/images/welcome_image.svg" />
					<Text fontWeight="bold" fontFamily="heading" fontSize="2xl">Ops. Pagina non trovata</Text>
					<Text fontSize="xl">Errore 404</Text>
					<Button colorPalette="primaryParent" onClick={() => navigate("/")}>Torna alla home</Button>
				</Flex>
				{/* <AvatarCarousel users={users} /> */}
			</Flex>

		</>
	)
}

export default NotFoundPage;